<form [formGroup]="form">
    <ols-credit-card-information
        [surchargeSettings]="surchargeSettings"
        [summary]="summary"
    ></ols-credit-card-information>
</form>
<div
    class="purchase-agreement"
    skeletonData
    [showSkeleton]="!purchaseAgreement"
    placeholderWidth="100%"
    placeholderHeight="1rem"
    *ngIf="isLoading || purchaseAgreement"
>
    By purchasing an online gift card you agree to our gift card policy:
    <br />
    {{ purchaseAgreement }}
</div>
